export const hebrewStrings = {
  hero: {
    appName: "Where2Exit",
    appSubtitle: "מוצא יציאות תחנות הרכבת הקלה קו אדום",
    title: "ניווט חכם לרכבת הקלה בתל אביב והמרכז",
    description: "לא עוד לצאת ביציאה השגויה ולבזבז זמן בחציית כבישים עמוסים. קבלו המלצות מותאמות אישית ליציאות תחנה שחוסכות זמן והופכות את היציאה מהרכבת הקלה לפשוטה ונוחה.",
    badges: {
      available: "זמין באייפון",
      free: "חינם לשימוש"
    }
  },
  
  features: {
    sectionTitle: "למה לבחור ב-Where2Exit?",
    sectionDescription: "יכולות מתקדמות שמשפרות את חוויית התחבורה הציבורית שלכם ברכבת הקלה",
    smartRecommendations: {
      title: "המלצות חכמות ליציאות תחנה",
      description: "אלגוריתם מתקדם שממליץ על יציאת התחנה הקרובה ביותר ליעד שלכם, וחוסך לכם זמן הליכה יקר בכל נסיעה ברכבת הקלה."
    },
    accessibility: {
      title: "נגישות מלאה במפות התחנות",
      description: "מצאו מסלולים נגישים בתחנות הרכבת הקלה עם מיקומי מעליות, רמפות ונתיבים ללא מחסומים ברכבת הקלה תל אביב."
    },
    bilingual: {
      title: "תמיכה דו-לשונית בתחנות הרכבת",
      description: "ממשק מלא בעברית ובאנגלית עבור כל נוסעי התחבורה הציבורית ברכבת הקלה ברחבי ישראל."
    },
    realtime: {
      title: "עדכונים בזמן אמת על תחנות הרכבת הקלה",
      description: "מידע בזמן אמת על תחנות הרכבת הקלה והוראות הליכה מעודכנות למפות התחנות."
    }
  },
  
  faq: {
    sectionTitle: "שאלות נפוצות על הרכבת הקלה",
    sectionDescription: "כל מה שצריך לדעת על השימוש ב-Where2Exit לרכבת הקלה בקו האדום",
    questions: {
      coverage: {
        question: "אילו תחנות רכבת קלה מכסה האפליקציה?",
        answer: "Where2Exit מכסה את כל 34 תחנות הרכבת הקלה בקו האדום מתחנה מרכזית פתח תקווה ועד הקוממיות בת ים. האפליקציה כוללת מפות תחנות מפורטות לתחנות תת-קרקעיות ועיליות ברכבת הקלה תל אביב ובערים נוספות."
      },
      algorithm: {
        question: "איך האפליקציה קובעת את יציאת התחנה הטובה ביותר?",
        answer: "האלגוריתם שלנו מנתח את המרחק הקצר ביותר מכל יציאות התחנה ביעד שלכם, תוך התחשבות בנגישות ובציוני דרך קרובים. זה מבטיח שתקבלו את ההמלצה הטובה ביותר לכל נסיעה ברכבת הקלה."
      },
      location: {
        question: "האם ניתן להשתמש באפליקציה ללא שירותי מיקום?",
        answer: "בהחלט! באפשרותכם לחפש יעדים באופן ידני, לעיין במפות התחנות, או לבחור מיקומים ללא שירותי מיקום. הגישה למיקום רק מספקת המלצות מותאמות יותר אישית לתחנות הרכבת הקלה."
      },
      offline: {
        question: "האם האפליקציה פועלת ללא אינטרנט?",
        answer: "מידע בסיסי על תחנות הרכבת הקלה ויציאות התחנה זמין ללא אינטרנט. מפות התחנות האינטראקטיביות וחיפוש יעדים דורשים חיבור לאינטרנט לחוויה מיטבית ברכבת הקלה."
      },
      pricing: {
        question: "האם האפליקציה חינמית לשימוש?",
        answer: "כן! Where2Exit חינמית לחלוטין להורדה ולשימוש. ללא מנויים, ללא רכישות בתוך האפליקציה וללא פרסומות - כל המידע על תחנות הרכבת הקלה זמין בחינם."
      },
      accuracy: {
        question: "עד כמה מדויקים זמני ההליכה מיציאות התחנה?",
        answer: "זמני ההליכה מחושבים על בסיס מהירות הליכה ממוצעת ומרחקים אמיתיים מיציאות התחנה. הזמנים עשויים להשתנות בהתאם לקצב האישי, לעומס נוסעים ולצרכי נגישות ברכבת הקלה."
      }
    }
  },
  
  contact: {
    sectionTitle: "זקוקים לעזרה?",
    sectionDescription: "אנחנו כאן כדי להבטיח שחוויית הרכבת הקלה שלכם תהיה חלקה ונעימה",
    support: {
      title: "תמיכה טכנית",
      description: "נתקלתם בבעיות באפליקציה? אנחנו כאן לעזור לכם לחזור למסלול ולהמשיך ליהנות מהרכבת הקלה.",
      email: "haggai.magen@gmail.com"
    },
    feedback: {
      title: "בקשות לתכונות חדשות",
      description: "יש לכם רעיונות לשיפור Where2Exit ומפות התחנות? נשמח לשמוע את ההצעות שלכם!",
      email: "haggai.magen@gmail.com"
    },
    responseTime: "אנחנו עונים בדרך כלל תוך 24 שעות"
  },
  
  footer: {
    appName: "Where2Exit",
    description: "הופכים את נסיעות הרכבת הקלה לקלות ונוחות ברחבי ישראל",
    stats: {
      stations: "תחנות רכבת קלה",
      cities: "ערים",
      exits: "יציאות תחנה"
    },
    copyright: "פותח באהבה עבור נוסעי התחבורה הציבורית בישראל.",
    version: "גירסה 1.0 • iOS 17.6+"
  }
};